export const defaultFrameInterval = 100.0
export const attackFrameInterval = 75.0